import { Descriptions, Tag, Button } from "antd";
import trans, { formatDateTime, formatDuration } from "../../../../utils";

export function GeneralTab({ data }) {
  const statusColors = {
    todo: `blue`,
    inProgress: `orange`,
    done: `green`,
    // delayed: `red`,
    unassigned: `default`,
  };

  const priorityColors = {
    low: `green`,
    medium: `orange`,
    high: `red`,
  };
  if (!data) {
    return;
  }
  const items = [
    {
      label: trans("Task Name"),
      children: data?.name,
      span: 4,
    },
    {
      label: trans("status"),
      span: 4,
      children: (
        <Tag
          color={statusColors[data.status] || statusColors.unassigned}
          className="text-capitalize"
        >
          {trans(data.status)}
        </Tag>
      ),
    },
    {
      label: trans("Type"),
      span: 4,
      children: `${trans(data.type)}`,
    },
    {
      label: trans("Priority"),
      span: 4,
      children: (
        <Tag
          color={priorityColors[data.priority] || priorityColors.unassigned}
          className="text-capitalize"
        >
          {trans(data.priority)}
        </Tag>
      ),
    },
    {
      label: trans("Created At"),
      span: 4,
      children: formatDateTime(data?.createdAt),
    },
    {
      label: trans("Created By"),
      span: 4,
      children: data?.createdBy.name,
    },
    {
      label: trans("Last Modified At"),
      span: 4,
      children: formatDateTime(data?.updatedAt),
    },
    {
      label: trans("Assigned Field Staff"),
      children: data?.assignedToId
        ? `${data?.assignedTo?.name || "Unassigned"}`
        : "Unassigned",
      span: 4,
    },
    {
      label: trans("Restrict Location"),
      children: (
        <Tag
          color={data?.enableGeofencing ? "green" : "red"}
          className="text-capitalize"
        >
          {trans(data?.enableGeofencing ? "Yes" : "No")}
        </Tag>
      ),
      span: 4,
    },
  ];

  const items2 = [
    {
      label: trans("Start Date"),
      span: 2,
      children: formatDateTime(data?.startTime),
    },
    {
      label: trans("Expected Duration"),
      span: 2,
      children: formatDuration(data?.expectedDuration),
    },
    {
      label: trans("Expected Completion"),
      span: 2,
      children: data?.completionTime
        ? formatDateTime(data?.completionTime)
        : "No Data",
    },
  ];

  if (data?.status === "inProgress" || data?.status === "done") {
    items2.push({
      label: trans("Started At"),
      span: 2,
      children: data?.actualStartTime
        ? formatDateTime(data?.actualStartTime)
        : "No Data",
    });
  }

  if (data?.status === "done") {
    items2.push({
      label: trans("Completed At"),
      span: 2,
      children: data?.actualCompletionTime
        ? formatDateTime(data?.actualCompletionTime)
        : "No Data",
    });
    items2.push({
      label: trans("Completed In"),
      span: 2,
      children: formatDuration(data?.actualDuration),
    });
  }

  return (
    <>
      <Descriptions
        title={
          <div className="fs-16 fw-700 brand-700">
            {trans("Basic Information")}
          </div>
        }
        size={"small"}
        bordered
        items={items.map((item) => ({
          ...item,
          labelStyle: { width: "200px" }, // adjust here
        }))}
        style={{ marginBottom: 24 }}
      />
      <Descriptions
        title={
          <div className="fs-16 fw-700 brand-700">
            {trans("Schedule & Progress")}
          </div>
        }
        size={"small"}
        bordered
        items={items2.map((item) => ({
          ...item,
          labelStyle: { width: "200px" }, // adjust here
        }))}
        style={{ marginBottom: 24 }}
      />
      {data?.customAttributes && (
        <Descriptions
          title={
            <div className="fs-16 fw-700 brand-700">
              {trans("Custom Attributes")}
            </div>
          }
          size={"small"}
          bordered
          items={data.customAttributes.map((item) => ({
            label: item?.name,
            span: 4,
            children:
              item.type === "boolean"
                ? trans(String(item.value))
                : item?.value || "No Data",
            labelStyle: { width: "200px" },
          }))}
        />
      )}
    </>
  );
}
